// extracted by mini-css-extract-plugin
export var centerText = "_91-8";
export var container = "_91-0";
export var doughnutContainer = "_91-7";
export var legend = "_91-a";
export var legendItemColorDisplay = "_91-b";
export var legendItemLabel = "_91-d";
export var legendItemValue = "_91-c";
export var lg = "_91-5";
export var maxWidth = "_91-9";
export var md = "_91-4";
export var responsive = "_91-6";
export var sm = "_91-3";
export var xs = "_91-2";
export var xxs = "_91-1";